import gql from 'graphql-tag'

export default gql`
    mutation SendTouchPoint($input: TouchPointInput!) {
        sendTouchPoint(input: $input) {
            status
        }
    }
`
